var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-book-menu" },
    [
      _c("com-button-icon", {
        staticClass: "vue-book-menu__icon",
        attrs: {
          title: "Mode: Tree",
          icon: "server",
          active: _vm.config.mode === _vm.DemoPageMode.Tree
        },
        nativeOn: {
          click: function($event) {
            _vm.config.mode = _vm.DemoPageMode.Tree
          }
        }
      }),
      _vm._v(" "),
      _c("com-button-icon", {
        staticClass: "vue-book-menu__icon",
        attrs: {
          title: "Mode: Search",
          icon: "search",
          active: _vm.config.mode === _vm.DemoPageMode.Search
        },
        nativeOn: {
          click: function($event) {
            _vm.config.mode = _vm.DemoPageMode.Search
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "vue-book-menu__filler" }),
      _vm._v(" "),
      _vm.config.mode === _vm.DemoPageMode.Tree
        ? [
            _vm.currentFile
              ? _c("com-button-icon", {
                  staticClass: "vue-book-menu__icon",
                  attrs: {
                    title: "Expand from Current File",
                    icon: "dot-circle"
                  },
                  nativeOn: {
                    click: function($event) {
                      _vm.$emit("openFolder")
                    }
                  }
                })
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }